import {
	useEffect,
	useRef,
} from 'react';
import { RIGHT_PANEL_MOBILE_BREAKPOINT } from '../../constants';
import { useRefDispatch } from 'contexts/RefContext';
import useScreenDims from 'hooks/useScreenDims';
import { FacetListModal } from './facetListModal';
import RoofDesktopView from './RightSidePanel/RoofDesktopView';
import RoofMobileView from './RightSidePanel/RoofMobileView';

export default function DisplayRoofData() {
	const refDispatch = useRefDispatch();
	const { width: screenWidth } = useScreenDims();
	const showMobileView = screenWidth <= RIGHT_PANEL_MOBILE_BREAKPOINT;
	const bottomDivRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		refDispatch({ type: 'KONVA_BOTTOM_DIV_REF', payload: { ref: bottomDivRef } });
	}, [refDispatch]);

	const RoofSidePanelComponent = showMobileView ? RoofMobileView : RoofDesktopView;
	return (
		<>
			<RoofSidePanelComponent
				ref={bottomDivRef}
			/>
			<FacetListModal />
		</>
	);
}